<template>
  <div class="newUserForm">
    <div class="surface-card p-4 shadow-2 border-round">
      <registerNewPersonForm />
    </div>
  </div>
</template>

<script>
import registerNewPersonForm from "./RegisterNewPersonForm.vue";
export default {
  name: "registerNewPerson",
  components: {
    registerNewPersonForm,
  },
};
</script>
